<template>
  <div style="width: 100%;" v-loading.body="loading">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.5em;">
          CHART OF ACCOUNTS LISTING
        </el-row>
      </el-col>
      <el-col class="small">
          <a @click="showJson = ! showJson">.&nbsp;</a>
      </el-col>
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <el-button @click="onSave">
            Save Changes
          </el-button>
          <el-button plain @click="generateReport" :disabled="disableReportRun">
            Run report
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
          Report Options
        </el-row>
      </el-col>
    </el-row>

    <!--
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Summary/Detail
      </el-col>
      <el-col :span="6">
        <el-radio-group v-model="reportOptions.type" @change="updateReportType">
          <el-radio-button label="detail">Detail</el-radio-button>
          <el-radio-button label="summary">Summary</el-radio-button>
          <el-radio-button label="list">List</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    -->

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Report Output
      </el-col>
      <el-col :span="4">
        <el-select v-model="reportOptions.format">
          <el-option
            v-for="opt in reportOutputFormats"
            :key="opt.value"
            :label="opt.label"
            :value="opt.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="clear"></div>
    <!-- <el-row type="flex" align="middle" justify="end" class="section">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
          Account Selection
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="24" :offset="1">
        <el-radio-group v-model="reportOptions.accountQuickPick" @change="updateAccounts" :disabled="loading || disableReportRun">
          <el-radio-button label="custom">Custom</el-radio-button>
          <el-radio-button label="all">All</el-radio-button>
          <el-radio-button label="headers">Headers Only</el-radio-button>
          <el-radio-button label="expenses">Expenses Only</el-radio-button>
          <el-radio-button label="balance">Balance Sheet Only</el-radio-button>
          <el-radio-button label="none">None</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row v-show="reportOptions.accountQuickPick==='custom'" type="flex" align="top" justify="start" class="headerRow">
      <el-col :span="24" :offset="1">
        <el-transfer
          ref="accountTransfer"
          v-model="selectedCodes.account_id"
          :data="accounts"
          :titles="[ 'Unselected Accounts', 'Selected Accounts' ]"
          :props="{ key: 'id', label: 'display_name' }"
          filterable
          filter-placeholder="Search Accounts"
        >
        </el-transfer>
      </el-col>
    </el-row> -->
    <el-row>
      <el-col>
        <account-list
          class="headerRow"
          name="accountList"
          ref="accountList"
          classes="ag-theme-balham"
          width="100%"
          :height="height"
          :iteration="iteration"
          :row-data="rowData"
        />
      </el-col>
    </el-row>

    <el-row v-if="showJson">
      <el-col>
        <textarea id="output" style="width: 100%; height: 500px;" v-model="prettyJson"></textarea>
      </el-col>
    </el-row>
    <el-row v-if="showJson">
      <el-col :span="1">
        <el-button plain @click="generateCustomReport" :disabled="disableReportRun">
          Run Customized Report
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { mapGetters } from 'vuex'
  import { notify } from '../../utils/helpers/Notify'
  import { buildInitPromiseIterable } from '../../utils/helpers/BuildPromiseIterable'
  import { sortObjectByProperty } from '../../utils/helpers/ObjectSorting'
  import { capitalizeFirstLetter } from '../../utils/helpers/StringOperations'
  import { AccountResource } from '@sigmacloud/sigma-client/dist/resources'
  import AccountList from '@/components/SigmaClientNew/AccountList.vue'
  import { reportMixins } from '../../Mixins/Reports'

  export default {
    name: 'AccountListCustom',
    mixins: [ reportMixins ],
    components: { AccountResource, AccountList },
    props: {
    },
    data () {
      const { getJasperHost } = this.$store.getters
      return {
        reportOptions: {
          transactionStatuses: [ 'posted', 'closed' ],
          accountQuickPick: 'all',
          type: 'detail',
          dates: 'datesAll',
          sort: 'account',
          status: 'all',
          format: 'pdf'
        },

        allCodes: {},
        selectedCodes: {
          account_id: [],
          company_id: undefined,
          production_id: undefined
        },
        jasperSettings: {
          reportServer: `${getJasperHost}rest_v2/reports/Revolution/Phoenix/`,
          reportName: 'account_listing'
        },

        reportOutputFormats: [
          { value: 'pdf', label: 'PDF' },
          { value: 'csv', label: 'CSV' }
        ],
        disableReportRun: false, // Disable run report button if false
        prettyJson: undefined,
        showJson: false,
        reportNotif: undefined,
        loading: false,

        rowData: undefined,
        originalCacheTimes: {
          // Numbers are here for default, but should be overwritten in beforeMount with actual default resource settings
          account: 60
        }
      }
    },

    computed: {
      username () { return this.$store.getters.getUser.username },
      accounts () {
        let accounts = []
        // FYI.  Element does not like the map method for the el-transfer component.  Must use a for loop
        for (const i in this.allCodes.accounts) {
          const account = this.allCodes.accounts[i]
          account.display_name = account.code + ' - ' + account.name + ' (' + account.type + ')'
          if (account.id) accounts.push(account)
        }
        return accounts
      },
      resources () {
        return {
          AccountResource
        }
      },
      height () {
        // Reducing by 3 % to handle sigma-frontend navbar
        return window.innerHeight * 0.73 + 'px'
      }
    },

    watch: {
    },

    methods: {
      resetComponent () {
        this.prettyJson = undefined
        this.clearStore()
      },
      clearStore () {
        // TODO
      },
      updateReportType (type) {
        this.jasperSettings.reportName = 'account_history_' + type
      },

      // Get all resources
      async getAllAccounts () {
        let queryFilters = { page_size: 100 }
        this.rowData = await this.resources.AccountResource.filterAll(queryFilters)
      },

      updateAccounts (type) {
        if (!type) return false
        switch (type) {
          case 'none':
            this.disableReportRun = false
            this.selectedCodes.account_id = []
            break
          case 'all':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.allCodes.accounts.map(account => account.id)
            break
          case 'headers':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.allCodes.accounts.filter(({type}) => type.toLowerCase() === 'header').map(acct => acct.id)
            break
          case 'expenses':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.allCodes.accounts.filter(({type}) => type.toLowerCase().match('expense')).map(acct => acct.id)
            break
          case 'balance':
            this.disableReportRun = false
            this.selectedCodes.account_id = this.allCodes.accounts.filter(({type}) => {
              if (type.toLowerCase().match('asset') || type.toLowerCase().match('liability') || type.toLowerCase().match('income')) return true
            }).map(acct => acct.id)
            break
          case 'custom':
            this.disableReportRun = false
            break
          default:
            return undefined
        }
        // The transfer table is one tick behind.  Force update now
        this.$forceUpdate()
        return true
      },
      selectReportFormat ({target}) {
        if (target.checked) {
          this.reportOptions.format = 'csv'
        } else {
          this.reportOptions.format = 'pdf'
        }
      },

      buildAccountList () {
        let json = {
          report: {
            report_title: 'Account Listing',
            report_subtitle: '',
            report_name: 'account_listing',
            printed_by: this.username,
            date_run: this.today(),
            company: (this.selectedCodes.company_id) ? (this.allCodes.companies.find(({id}) => id === this.selectedCodes.company_id) || {}).name : this.allCodes.companies[0].name,
            project: (this.selectedCodes.production_id) ? (this.allCodes.productions.find(({id}) => id === this.selectedCodes.production_id) || {}).name : this.allCodes.productions[0].name,
            accounts: this.reportOptions.accountQuickPick,
            num_items: 0,
            data: []
          }
        }

        // Put finished data here
        for (const i in this.selectedCodes.account_id) {
          const selected = this.selectedCodes.account_id[i]
          let account = this.allCodes.accounts.find(acct => acct.id === selected)
          let parent = this.allCodes.accounts.find(parent => parent.id === account.parent) || {}

          account.parent_code = parent.code || ''
          account.parent_name = parent.name || ''
          account.parent_type = parent.type || ''
          account.posting = account.postable ? 'Yes' : 'No'

          const metadata = JSON.parse(account.meta_data) || ''
          let mappings = []
          if (metadata && metadata.alternate_mappings && metadata.alternate_mappings.corporate) {
            const code = metadata.alternate_mappings.corporate.code || null
            account.corporate_mapping = code
            mappings.push('Corporate Mapping: ' + code)
          }
          if (metadata && metadata.alternate_mappings && metadata.alternate_mappings.netflix) {
            const code = metadata.alternate_mappings.netflix.code || null
            account.netflix_mapping = code
            mappings.push('Netflix Mapping: ' + code)
          }
          if (metadata && metadata.alternate_mappings && metadata.alternate_mappings.amazon) {
            const code = metadata.alternate_mappings.amazon.code || null
            account.amazon_mapping = code
            mappings.push('Amazon Mapping: ' + code)
          }

          if (mappings.length > 0) {
            account.mappings = mappings.join(', ')
          }

          json.report.data.push(account)
          json.report.num_items++
        }
        return json
      },

      buildCsvData (sortedAccounts) {
        // Available Fields: active, alias_name, alias_type, default_accounts, default_tax_code, display_name, petty_cash_account, petty_cash_custodian, petty_cash_custodian_account, petty_cash_enabled, phone_cell, phone_home, w9
        let detailedColumns = { 'Account Number': 'code', 'Account Name': 'name', 'Account Type': 'type', 'Parent Code': 'parent_code', 'Parent Name': 'parent_name', 'Parent Type': 'parent_type', 'Allow Posting': 'posting', 'Description': 'description', 'Data Mappings': 'mappings' }
        let summaryColumns = { 'Account Number': 'code', 'Account Name': 'name', 'Account Type': 'type', 'Parent': 'parent_code', 'Allow Posting': 'postable' }

        let columnMap = (this.reportOptions.type === 'summary') ? summaryColumns : detailedColumns

        return new Promise((resolve, reject) => {
          this.disableReportRun = false
          let finalCsv = this.createCsv(sortedAccounts, columnMap)
          if (finalCsv) resolve(finalCsv)
          else reject('Could not build CSV.')
        })
      },

      onSave () {
        this.$refs['accountList'].save()
      },

      generateReport () {
        this.loading = true
        this.disableReportRun = true
        const json = this.buildAccountList()

        if (this.reportOptions.format === 'csv') {
          this.buildCsvData(json.report.data)
            .then((resCsv) => {
              this.loading = false
              this.prettyJson = resCsv
              this.createNotification('Success', 'CSV is Ready. ', 'success', false, true, 'AccountList')
              return true
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
        } else {
          this.prettyJson = JSON.stringify(json, null, 2)
          this.getJsonUrl(json)
            .then(resJsonUrl => {
              // PDF version of the report
              let report = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.pdf?net.sf.jasperreports.json.source=' + resJsonUrl
              // HTML version of the report
              let preview = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.html?net.sf.jasperreports.json.source=' + resJsonUrl
              return this.getReportUrl(report)
            })
            .then(reportUrl => {
              this.loading = false
              this.createNotification('Success', 'Report is Ready. ', 'success', reportUrl)
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
        }
      }
    },

    beforeCreate () {
    },

    created () {
      // Load data to be used for validation
      this.disableReportRun = true
      this.getCompanyData()
        .then(response => {
          this.allCodes = Object.assign({}, response.data)
          this.updateAccounts(this.reportOptions.accountQuickPick)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.disableReportRun = false
        })

      this.originalCacheTimes.account = AccountResource.cacheMaxAge
      AccountResource.cacheMaxAge = 7200000
    },

    async mounted () {
      this.getAllAccounts()
    },

    beforeDestroy () {
      AccountResource.cacheMaxAge = this.originalCacheTimes.account
      this.resetComponent()
    },
    async beforeRouteLeave (to, from, next) {
      if (this.rowData.filter((row) => Object.keys(row.changes).length).length && !this.$store.getters.getRouteLeaveConfirmation) {
        return this.$store.dispatch('setDestinationRoute', to)
        .then(() => this.$store.dispatch('changeModalVisibility', { entityType: 'changeLossModal', visible: true }))
        .catch(e => console.log(e))
      } else {
        next()
      }
    }
  }
  
</script>
<style scoped>
  .small { font-size: 8px; }
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 40px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
  .m-top-20 { margin-top: 20px; }
  .m-right-20 { margin-right: 20px; }
</style>
<style>
  .el-select { display: block; }
  .el-transfer-panel { width:36%; max-width: 350px }
  .el-transfer-panel__body { min-height: 400px }
  .el-transfer-panel__list { min-height: 360px }
  /* border: 1px solid #d1dbe5; box-shadow: 0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04); display: inline-block; width: 30%; position: relative; height: 500px; */
</style>



// WEBPACK FOOTER //
// src/components/Reports/AccountListCustom.vue